import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderService } from './loader.service';
import { LoaderState } from './loader';

@Component({
    selector: 'cria-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.css'],
    encapsulation:ViewEncapsulation.None
    
})
export class LoaderComponent implements OnInit {

    show = false;

    private subscription: Subscription;

    constructor(
        private loaderService: LoaderService
    ) { }

    ngOnInit() { 
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                this.show = state.show;
                console.log('show');
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}